// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DayStrip-module__root___aWEwz {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.DayStrip-module__arrow___mQmU4 {
  flex-shrink: 0;
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  color: #52525b;
  cursor: pointer;
}
.DayStrip-module__arrow___mQmU4:hover:not(:disabled) {
  border-color: #18181b;
  color: #18181b;
}
.DayStrip-module__arrow___mQmU4:disabled {
  color: #d4d4d8;
  cursor: default;
}

.DayStrip-module__chips___MqT7F {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
}

.DayStrip-module__hairline___OPdA5 {
  flex-shrink: 0;
  width: 1px;
  height: 20px;
  margin: 0 4px;
  background: #d4d4d8;
}

.DayStrip-module__summary___lNu88 {
  flex: 0 1 auto;
  min-width: 0;
  margin-left: auto;
  overflow: hidden;
  font-size: 14px;
  color: #71717a;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.DayStrip-module__panel___LVp4R {
  padding: 0;
  gap: 6px;
  background: transparent;
  border: none;
  border-radius: 0;
}
.DayStrip-module__panel___LVp4R .DayStrip-module__summary___lNu88 {
  display: none;
}
.DayStrip-module__panel___LVp4R .DayStrip-module__chips___MqT7F {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-mask-image: linear-gradient(to right, transparent, #000 16px, #000 calc(100% - 16px), transparent);
  mask-image: linear-gradient(to right, transparent, #000 16px, #000 calc(100% - 16px), transparent);
}
.DayStrip-module__panel___LVp4R .DayStrip-module__chips___MqT7F::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/DayStrip.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;EACA,cAAA;AACJ;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;;AAIA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,UAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AADF;AAGE;EACE,aAAA;AADJ;AAIE;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,0GAAA;EACA,kGAAA;AAFJ;AAII;EACE,aAAA;AAFN","sourcesContent":[".root {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.arrow {\n  flex-shrink: 0;\n  font-family: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #52525b;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: #18181b;\n    color: #18181b;\n  }\n\n  &:disabled {\n    color: #d4d4d8;\n    cursor: default;\n  }\n}\n\n.chips {\n  display: flex;\n  flex: 0 0 auto;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.hairline {\n  flex-shrink: 0;\n  width: 1px;\n  height: 20px;\n  margin: 0 4px;\n  background: #d4d4d8;\n}\n\n.summary {\n  flex: 0 1 auto;\n  min-width: 0;\n  margin-left: auto;\n  overflow: hidden;\n  font-size: 14px;\n  color: #71717a;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.panel {\n  padding: 0;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n\n  .summary {\n    display: none;\n  }\n\n  .chips {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow-x: auto;\n    scrollbar-width: none;\n    -webkit-mask-image: linear-gradient(to right, transparent, #000 16px, #000 calc(100% - 16px), transparent);\n    mask-image: linear-gradient(to right, transparent, #000 16px, #000 calc(100% - 16px), transparent);\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DayStrip-module__root___aWEwz`,
	"arrow": `DayStrip-module__arrow___mQmU4`,
	"chips": `DayStrip-module__chips___MqT7F`,
	"hairline": `DayStrip-module__hairline___OPdA5`,
	"summary": `DayStrip-module__summary___lNu88`,
	"panel": `DayStrip-module__panel___LVp4R`
};
module.exports = ___CSS_LOADER_EXPORT___;
